import React from 'react';
import NoticeSiteHasBeenArchived from '../../common/lib/NoticeSiteHasBeenArchived';
import { MultiLang } from '../../config';

interface Props {
    lang: MultiLang;
}

const Welcome = (props: Props) => {
    const { lang } = props;
    return (
        <>
            <NoticeSiteHasBeenArchived lang={lang} />
            <h4>This website have a database to see and upload files for BMI.</h4>
            <p>
                If you want to get papers,  click "Database" on left side  menu.

            </p>
            <h4>About Original Contents</h4>
            <p>
                BMI-related materials (Movie, Picture, Data, Program) provided by scientists are listed.
            </p>
        </>
    );
}

export default Welcome;